import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'brackets-angle', 'IconBracketsAngle', [["path",{"d":"M8 4l-5 8l5 8","key":"svg-0"}],["path",{"d":"M16 4l5 8l-5 8","key":"svg-1"}]]);